import { Box } from "@mui/material";
import { NotesTabPanelProps } from "../../interfaceTypes";

export function TabPanel(props: NotesTabPanelProps) {
    const { children, value, index, pb, ...other } = props;

    return (
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        pb={pb}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </Box>
    );
  }

export function a11yProps(index: number, id: string) {
    return {
      id: `${id}-tab-${index}`,
      "aria-controls": `${id}-tabpanel-${index}`,
    };
  }
